<template>
  <div>
    <el-tabs v-model="activeTabName" tab-position="left">
      <el-tab-pane name="updateHistories" label="更新历史">
        <UpdateHistoriesPage v-if="activeTabName == 'updateHistories'" />
      </el-tab-pane>
      <el-tab-pane name="update" label="更新">
        <UpdatePage v-if="activeTabName == 'update'" @requestToSwitchTab="onRequestedToSwitchTab" />
      </el-tab-pane>
      <el-tab-pane name="packExcels" label="打包excel">
        <PackExcelsPage v-if="activeTabName == 'packExcels'" @requestToSwitchTab="onRequestedToSwitchTab" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UpdateHistoriesPage from "./server-update-tab-pages/UpdateHistories";
import PackExcelsPage from "./server-update-tab-pages/PackExcels";
import UpdatePage from "./server-update-tab-pages/Update";

export default {
  data() {
    return {
      activeTabName: "updateHistories",
    };
  },

  components: {
    UpdateHistoriesPage,
    PackExcelsPage,
    UpdatePage,
  },

  methods: {
    onRequestedToSwitchTab(tabName) {
      console.log(tabName)

      this.activeTabName = tabName;
    }
  }
};
</script>